import React from "react";
import store from "./redux/store";
import { logout } from "./redux/actions/userActions";

export default class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { error: null, errorInfo: null };
    }

    componentDidCatch(error, errorInfo) {
      console.log("ErrorBoundary render Error", error, errorInfo);
      store.dispatch(logout());
    }

    render() {
      return this.props.children;
    }

}
